module.exports = {"title":"Outlet","outlet_details":"Outlet Details","create_outlet":"Create New Outlet","pricebook":"Pricebook","central_devices":"Central Devices"};


//////////////////
// WEBPACK FOOTER
// ./resources/lang/en/outlet.php
// module id = 2enI
// module chunks = 50